import React, {useEffect, useState} from 'react';
import {PageType} from "../../models/api/codegen/code";
import {getChessLiveSportId, getHomePage, getPage} from "../../spirsApi/api-client";
import {Row} from "../base/Row";
import {useTranslation} from "react-i18next";
import {Carousel} from "../Carousel/Carousel";
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";
import {clearLiveTree} from "../../store/spirs/actions";
import {useLocation, useParams} from 'react-router-dom';
import { useBanners } from '../../utils/useBanners';

export const DynamicComponent = () => {
    const location = useLocation();
    const params = useParams();
    const {t} = useTranslation();
    const [page, setPage] = React.useState<PageType | undefined>(undefined);
    const {slides} = useBanners();
    const [chess, setChess] = useState<Number | null>(null);
    const player = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);
    const dispatch = useDispatch();

    useEffect(() => {
        player && getChessLiveSportId({player}).then(res => res && setChess(res.value))
    }, [player]);

    useEffect(() => {
        if (location.pathname === "/" || location.pathname.startsWith('/sessiontoken')) {
            getHomePage().then(data => data && setPage(data.value));
        } else if (params.route) {
            getPage(params.route).then(data => data && setPage(data.value));
        }
        return () => {
            dispatch(clearLiveTree())
        }
    }, [location])

    if (!page) {
        return <></>
    }
    return (
        <>
            {page.title && (
                <div className="tablet:m-[16px]">
                    {slides && slides.length !== 0 && (
                        <div className="pb-[24px]">
                            <Carousel carouselSlides={slides} autoplay/>
                        </div>
                    )}
                    <div>
                        <div className="max-tablet:hidden text-[16px] notebook:text-[20px] uppercase font-medium">{page.translate ? t(page.title) : page.title}</div>
                    </div>
                </div>
            )}
            {page.rows.map((row, i) => <div key={i} className="mb-[20px]"><Row row={row}/></div>)}
        </>
    )
}
